var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHallesche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37568_32731)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.293C0 15.293 0.583612 16.3179 2.14787 18.027C2.80902 18.7495 3.76495 19.7276 4.83591 20.439C5.86938 21.2024 7.07154 21.9232 8.2098 22.4148C10.5622 23.4934 13.5697 24.2321 16.9845 24.0233C18.7004 23.9194 19.3973 23.6297 19.3973 23.6297C19.3973 23.6297 17.6516 23.4968 16.1495 22.8834C14.7471 22.3279 14.0102 21.7485 13.1582 21.1393C12.3582 20.5651 11.2497 19.3433 10.6601 18.4436C9.91719 17.3079 9.642 16.3145 9.642 16.3145C9.642 16.3145 8.11778 16.5309 7.00253 16.5497C5.82252 16.5693 4.16028 16.5292 2.91467 16.1978C1.42112 15.8025 0 15.293 0 15.293Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1716 15.898C20.3526 15.898 22.1206 14.13 22.1206 11.949C22.1206 9.76802 20.3526 8 18.1716 8C15.9907 8 14.2227 9.76802 14.2227 11.949C14.2227 14.13 15.9907 15.898 18.1716 15.898Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7793 21.9543C17.3759 21.4738 18.5534 20.8544 19.8765 19.8592C20.962 19.0447 21.4527 18.4535 22.1965 17.3459C22.8116 16.4308 23.0919 15.86 23.4634 14.8223C23.7744 13.9558 23.9022 13.442 24.0317 12.5312C25.4809 12.9044 26.442 12.9964 27.887 13.0177C29.5892 13.0433 30.4157 12.8899 32.0012 12.5679C32.0012 12.5679 31.8828 13.0016 31.4926 13.8271C31.0666 14.7055 30.6423 15.5729 30.1874 16.2689C29.3217 17.5921 28.7671 18.3222 27.6016 19.3915C26.5681 20.3389 26.0356 20.8654 24.8488 21.53C23.7727 22.1307 23.1158 22.4348 21.9068 22.6819C20.9253 22.8821 20.3426 22.9051 19.3423 22.8421C17.9127 22.7501 17.1561 22.5209 15.7793 21.9543Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37568_32731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHallesche);
export default __webpack_public_path__ + "static/media/hallesche.58024cc292688f26157850e88e6a403a.svg";
export { ForwardRef as ReactComponent };